<template>
  <transition mode="out-in" v-if="!mobile">
    <div class="main-transition" >
      <div class="main" v-bind:class="[{'digital-active': digital.isActive}, {'video-active': video.isActive}, {'events-active': events.isActive}, isChrome]">
        <div class="main__border"></div>
        <div class="main__inner">
          <div class="main__info" >
            Эксперты в области Digital,<br>Video и BTL, работающие<br>в одной команде
          </div>
          <div class="main__frontstage" >
            <div v-bind:style="scale" class="main__list">
              <div class="main__item">
                <div class="link-digital">
                  <div class="link-digital__inner">
                    <div class="link-digital__logo"></div>
                    <svg id="digital_svg" width="467px" height="754px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <polygon id="path-1" :points="digitalBg"></polygon>
                        <polygon id="path-2" :points="digitalHero"></polygon>
                      </defs>
                      <mask id="mask-figure" fill="white">
                        <use xlink:href="#path-1"></use>
                      </mask>
                      <mask id="mask-figure-2" fill="white">
                        <use xlink:href="#path-2"></use>
                      </mask>
                      <g mask="url(#mask-figure)">
                        <image x="-200" y="0" width="1800" height="1010" xlink:href="@/assets/desktop@1x/bg/1.jpg"></image>
                        <image id="digital-hero-decor" x="150" y="-50" width="705" height="769" xlink:href="@/assets/desktop@1x/pic/Decor_03.png"></image>
                        <image id="digital-hero-decor-2" x="-10" y="100" width="705" height="769" xlink:href="@/assets/desktop@1x/pic/Decor_01.png"></image>
                      </g>
                      <g mask="url(#mask-figure-2)">
                        <image id="digital-hero-light" x="-90" y="110" width="382" height="800" xlink:href="@/assets/desktop@1x/pic/light_preview.png"></image>
                        <image id="digital-hero" x="0" y="230" width="411" height="619" xlink:href="@/assets/desktop@1x/pic/hero_preview.png"></image>
                      </g>
                      <g cursor="pointer" pointer-events="all" @mouseenter="mouseOverDigital" @mouseleave="mouseOverDigital">
                        <router-link @click.native="gaClickDigital" class="main__link" to="/detail/digital" tag="polygon" :points="digital.path.bg[0]" fill="none"></router-link>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="main__item">
                <div class="link-video">
                  <div class="link-video__inner">
                    <div class="link-video__logo"></div>
                    <div class="link-video__copter"></div>
                    <div class="link-video__camera"></div>
                    <svg width="392px" height="754px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <polygon id="path-3" :points="videoBg"></polygon>
                      </defs>
                      <mask id="mask-figure-3" fill="white">
                        <use xlink:href="#path-3"></use>
                      </mask>
                      <g mask="url(#mask-figure-3)">
                        <image id="video-bg" x="-1035" y="-85" width="1800" height="1010" xlink:href="@/assets/desktop@1x/bg/2.jpg"></image>
                        <image id="video-hero" x="-175" y="242" width="622" height="651" xlink:href="@/assets/desktop@1x/pic/video/superhero_02_preview.png"></image>
                      </g>
                      <g cursor="pointer" pointer-events="all" @mouseenter="mouseOverVideo" @mouseleave="mouseOverVideo">
                        <router-link @click.native="gaClickVideo" class="main__link" to="/detail/video" tag="polygon" :points="video.path.bg[0]" fill="none"></router-link>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="main__item">
                <div class="link-events">
                  <div class="link-events__inner">
                    <div class="link-events__logo"></div>
                    <div class="link-events__sticker-3"></div>
                    <div class="link-events__sticker"></div>
                    <svg width="377px" height="754px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <polygon id="path-4" :points="eventsBg"></polygon>
                      </defs>
                      <mask id="mask-figure-4" fill="white">
                        <use xlink:href="#path-4"></use>
                      </mask>
                      <g mask="url(#mask-figure-4)">
                        <image id="events-bg" x="-600" y="-210" width="1400" height="1010" xlink:href="@/assets/desktop@1x/bg/3.jpg"></image>
                        <image id="events-hero" x="-91" y="200" width="523" height="580" xlink:href="@/assets/desktop@1x/pic/events/superhero_03_preview.png"></image>
                      </g>
                      <g cursor="pointer" pointer-events="all" @mouseenter="mouseOverEvents" @mouseleave="mouseOverEvents">
                        <router-link @click.native="gaClickBtl" class="main__link" to="/detail/events" tag="polygon" :points="events.path.bg[0]" fill="none"></router-link>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
  <div class="mobile-main__inner" :class="mobileActiveItem" v-else>
    <div class="showLandscapeLock" v-if="showLandscapeLock">
      <i></i>
      <span>Поверните телефон на 90 градусов</span>
    </div>
      <div class="preloader">
          <div></div>
          <span>Загрузка</span>
      </div>
    <div class="mobile-main__info" :class="[{'mobile-main__menu_active' : mobileMenuOpen }]">
        <router-link @click.native="gaClickLogo" to="/" > 
          <Logo :mobile="mobile"></Logo>
        </router-link>
        <span class="mobile-main__info-text" v-show="!mobileActiveItem">Эксперты в области Digital,<br>Video и BTL, работающие<br>в одной команде</span>
        <div class="mobile-main__menu">
              <svg class="mobile-main__menu-ico" @click="onMobileMenuTap()" v-show="!mobileMenuOpen" width="47" height="58" viewBox="0 0 47 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M86.0322 3.84326L54.1895 -28L0 26V58H32.001L86.0322 3.84326Z" fill="white"/>
                <path class="mobile-main__menu-stripe mobile-main__menu-stripe_0" d="M3 32H28V36L3 37V32Z" fill="#171D29"/>
                <path class="mobile-main__menu-stripe mobile-main__menu-stripe_1" d="M3 41L28 40V44L3 45V41Z" fill="#171D29"/>
                <path class="mobile-main__menu-stripe mobile-main__menu-stripe_2" d="M3 49.5L28 48V53.5H3V49.5Z" fill="#171D29"/>
              </svg>
              <svg class=" mobile-main__menu-ico mobile-main__menu-ico_close" v-show="mobileMenuOpen" @click="onMobileMenuTap()" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="mobile-main__menu-stripe" d="M0.707107 18.3848L17.6777 4.11272e-06L20.5061 2.82843L3.53553 21.2132L0.707107 18.3848Z" fill="#171D29"/>
                <path class="mobile-main__menu-stripe" d="M2.93934 1.06066L21.6777 17.6777L17.7886 21.5668L0.110913 3.88909L2.93934 1.06066Z" fill="#171D29"/>
              </svg>
              <div class="mobile-main__menu-wrapper">
                <div class="mobile-main__menu-list">
                  <div @click="mobileTapItem('digital', true); gaClickNav('digital');" :class="[{'mobile-main__menu-list-item_active' : mobileActiveItem == 'digitalActiveItem'}]" class="mobile-main__menu-list-item">DIGITAL</div>
                  <div @click="mobileTapItem('video', true); gaClickNav('video');" :class="[{'mobile-main__menu-list-item_active': mobileActiveItem == 'videoActiveItem'}]" class="mobile-main__menu-list-item">VIDEO PROD</div>
                  <div @click="mobileTapItem('events', true); gaClickNav('events');" :class="[{'mobile-main__menu-list-item_active' : mobileActiveItem == 'eventsActiveItem'}]" class="mobile-main__menu-list-item">BTL&EVENTS</div>
                </div>
                <div class="mobile-main__menu-contacts">
                  <!-- <a @click="gaClickPhone" href="tel:+74952279011" class="mobile-main__menu-phone">+7 495 227-90-11</a> -->
                  <a @click="gaClickEmail" href="mailto:hello@whynotgroup.ru" class="mobile-main__menu-mail">HELLO@WHYNOTGROUP.RU</a>
                </div>
              </div>
        </div>
    </div>

    <transition name="fade">
      <div id="digital-item" class="mobile-main__item" v-show="mobileItemIsShow || mobileActiveItem == 'digitalActiveItem'">
          <div v-show="mobileItemIsShow" @click="mobileTapItem('digital', null); gaClickDigital();" class="mobile-main__item-link"></div>
          <img src="@/assets/mobile@1x/pic/digital_logo.png" width="163vmin" height="63vmin" id="mobile-digital-hero-logo">
          <span id="mobile-digital-build-0" style="display:none;"></span>
          <span id="mobile-digital-build-1" style="display:none;"></span>
          <svg id="mobile-digital_svg" 
                width="100%" 
                height="100%"
                viewBox="0 0 1000 1000"
                preserveAspectRatio="none"
                class="mobile-main__svg" 
                xmlns="http://www.w3.org/2000/svg" 
                xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
          
              </defs>
              <mask id="mobile-mask-figure-1" fill="white">
                <polygon id="mobile-path-1" :points="digitalPoints"></polygon>
              </mask>
              <g mask="url(#mobile-mask-figure-1)">
                <image x="0"
                        y="0"
                        width="100%"
                        height="100%"
                        preserveAspectRatio="none"
                        xlink:href="@/assets/mobile@1x/bg/1.png"></image>
                <image id="mobile-digital-hero" 
                      x="0"
                      y="50"
                      :width="mobileSuperAspectRatioCalcWidth(386)"
                      :height="mobileSuperAspectRatioCalcHeight(302)"
                      xlink:href="@/assets/mobile@1x/pic/hero_preview.png" preserveAspectRatio="none"></image>
                <image x="0"
                        y="160"
                        id="digital-hero_preview-2"
                        width="100%"
                        height="85%"
                        preserveAspectRatio="none"
                        transform="matrix(1,0,0,1,0,568)"
                        xlink:href="@/assets/mobile@1x/pic/hero_preview-2.png"></image>
              </g>
          </svg>

          <div class="mobile-main__info-text" id="info-digital-text">
            Полный спектр Digital услуг: стратегия и креатив, разработка и ведение SMM и media-кампаний, собственное производство мобильных приложений и проектов любой сложности силами внутреннего production-отдела
          </div>

          <div class="mobile-main__link-group" id="link-digital-group">
            <div class="mobile-main__link mobile-main__link_green mobile-main__link_bgreen" tabindex="1">
              <a @click="gaClickDititalPortfolio" target="_blank" href="https://whynotdigital.ru/">смотреть Портфолио</a>
            </div>
            
            <!-- <div class="mobile-main__link mobile-main__link_green mobile-main__link_btransp" tabindex="1">
              <a @click="gaClickDititalSite" target="_blank" href="http://w-not.ru/" >перейти на сайт</a>
            </div> -->
          </div>

            <button @click.stop="mobileTapItem('video', null, 'digital'); gaClickNext();" class="mobile-main__angle-arrow mobile-main__angle-arrow_yellow"></button>
      </div>
    </transition>
    <transition name="fade">
      <div id="video-item" class="mobile-main__item" v-show="mobileItemIsShow || mobileActiveItem == 'videoActiveItem'">
              <div v-show="mobileItemIsShow" @click="mobileTapItem('video', null); gaClickVideo();" class="mobile-main__item-link"></div>
              <img src="@/assets/mobile@1x/pic/video_logo.png" width="163" height="63" id="mobile-video-hero-logo">
              <img src="@/assets/mobile@1x/pic/Copter_01.png" width="76" height="66" id="copter">
              <img src="@/assets/mobile@1x/pic/camera.png" width="88" height="88" id="camera">
              <svg 
                  width="100%" 
                  height="100%"
                  viewBox="0 0 1000 1000"
                  preserveAspectRatio="none"
                  class="mobile-main__svg" 
                  xmlns="http://www.w3.org/2000/svg" 
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <mask id="mobile-mask-figure-2" fill="white">
                      <polygon id="mobile-path-2" :points="videoPoints"></polygon>
                  </mask>
                  <g mask="url(#mobile-mask-figure-2)">
                    <image x="0"
                            y="0"
                            id="bg2"
                            width="100%"
                            height="100%"
                            preserveAspectRatio="none"
                            xlink:href="@/assets/mobile@1x/bg/2.png"></image>
                    <image x="0"
                            y="0"
                            id="mobile-video-build-0"
                            :width="mobileSuperAspectRatioCalcWidth(208)"
                            :height="mobileSuperAspectRatioCalcHeight(340)"
                            preserveAspectRatio="none"
                            xlink:href="@/assets/mobile@1x/pic/city_02.png"></image>
                    <image x="516"
                            y="40"
                            id="mobile-video-hero"
                            :width="mobileSuperAspectRatioCalcWidth(285)"
                            :height="mobileSuperAspectRatioCalcHeight(328)"
                            preserveAspectRatio="none"
                            xlink:href="@/assets/mobile@1x/pic/superhero_02.png"></image>
                    <image x="0"
                            y="0"
                            id="mobile-video-build-1"
                            width="100%"
                            height="100%"
                            preserveAspectRatio="none"
                            transform="matrix(1,0,0,1,0,1000)"
                            xlink:href="@/assets/mobile@1x/pic/city_03.png"></image>
                    <image id="video-hero_preview-2" 
                            x="0"
                            y="200"
                            width="80%"
                            height="80%"
                            transform="matrix(1,0,0,1,0,568)"
                            preserveAspectRatio="none"
                            xlink:href="@/assets/mobile@1x/pic/superhero_04.png"></image>
                  </g>
                  <use x="47%" y="-20" xlink:href="#copter" />
                  <use x="-70" y="57%" xlink:href="#camera"  />
              </svg>
              <div class="mobile-main__info-text" id="info-video-text">
                Создание видеороликов от разработки синопсиса и раскадровки, до организации и полного контроля съемок с использованием лучшего мирового оборудования и привлечением всемирно известных имен
              </div>

              <div class="mobile-main__link-group" id="link-video-group">
                <div class="mobile-main__link mobile-main__link_pink mobile-main__link_bgpurpule" tabindex="1">
                  <a @click="gaClickVideoPortfolio" target="_blank" href="https://vimeo.com/whynotpro/videos">смотреть работы</a>
                </div>

                <div class="mobile-main__link-group_flex">
                  <!-- <div class="mobile-main__link mobile-main__link_short" tabindex="1">
                    <a @click="gaClickVideoSite" target="_blank" href="http://w-not.pro/">перейти на сайт</a>
                  </div> -->
                  <!-- <div class="mobile-main__link mobile-main__link_small" tabindex="1">
                    <a @click="gaClickVideoVimeo" target="_blank" href="https://vimeo.com/whynotpro/videos"></a>
                  </div> -->
                </div>
              </div>
            <button @click.stop="mobileTapItem('digital', null, 'video'); gaClickPrev();"  class="mobile-main__angle-arrow mobile-main__angle-arrow_green"></button>
            <button @click.stop="mobileTapItem('events', null, 'video'); gaClickNext();"  class="mobile-main__angle-arrow mobile-main__angle-arrow_orange"></button>
      </div>
    </transition>

    <transition name="fade2">
      <div id="events-item" class="mobile-main__item" v-show="mobileItemIsShow || mobileActiveItem == 'eventsActiveItem'">
              <div v-show="mobileItemIsShow" @click="mobileTapItem('events', null); gaClickBtl();" class="mobile-main__item-link"></div>
              <img src="@/assets/mobile@1x/pic/btl_logo.png" width="190" height="60" id="mobile-events-hero-logo">
              <img src="@/assets/mobile@1x/pic/paper_01.png" width="52" height="56" id="paper_01">
              <img src="@/assets/mobile@1x/pic/paper_02.png" width="38" height="39" id="paper_02">
              <svg 
                  width="100%" 
                  height="100%"
                  viewBox="0 0 1000 1000"
                  preserveAspectRatio="none"
                  class="mobile-main__svg" 
                  xmlns="http://www.w3.org/2000/svg" 
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <mask id="mobile-mask-figure-3" fill="white">
                    <polygon id="mobile-path-3" :points="eventsPoints"></polygon>
                  </mask>
                  <g mask="url(#mobile-mask-figure-3)">
                    <image x="0"
                            y="0"
                            width="100%"
                            height="100%"
                            preserveAspectRatio="none"
                            xlink:href="@/assets/mobile@1x/bg/3.png"></image>
                    <image x="0"
                            y="180"
                            id ="mobile-events-build-0"
                            width="65%"
                            height="85%"
                            preserveAspectRatio="none"
                            xlink:href="@/assets/mobile@1x/pic/bg_road.png"></image>
                    <image x="0"
                            y="0"
                            id ="mobile-events-build-1"
                            width="100%"
                            height="100%"
                            preserveAspectRatio="none"
                            transform="matrix(1, 0, 0, 1, 0, 1000)"
                            xlink:href="@/assets/mobile@1x/pic/city_04.png"></image>
                    <image x="0"
                            y="250"
                            id ="events-hero_preview-2"
                            width="100%"
                            height="75%"
                            preserveAspectRatio="none"
                            transform="matrix(1,0,0,1,0,1000)"
                            xlink:href="@/assets/mobile@1x/pic/superhero_05.png"></image>
                    <image x="0"
                            id ="mobile-events-hero"
                            y="18%"
                            :width="mobileSuperAspectRatioCalcWidth(272)"
                            :height="mobileSuperAspectRatioCalcHeight(264)"
                            preserveAspectRatio="none"
                            xlink:href="@/assets/mobile@1x/pic/superhero_03.png"></image>
                    <image x="690"
                            y="0"
                            id ="book_01"
                            width="310"
                            height="182"
                            preserveAspectRatio="none"
                            xlink:href="@/assets/mobile@1x/pic/book_01.png"></image>
                  </g>
                  <use x="78%" y="0" xlink:href="#paper_01" />
                  <use x="82%" y="82%" xlink:href="#paper_02"  />
              </svg>
              <div class="mobile-main__info-text" id="info-events-text">
                Разработка и реализация BTL и Promo-кампаний, <br> проведение Event любой сложности и направленности
              </div>

              <div class="mobile-main__link-group" id="link-events-group">
                <div class="mobile-main__link mobile-main__link_yellow mobile-main__link_bgorange" tabindex="1">
                  <a @click="$modal.show('video'); gaClickBtlPortfolio();">смотреть кейс</a>
                </div>
              </div>
              <button @click.stop="mobileTapItem('video', null, 'events'); gaClickPrev();"  class="mobile-main__angle-arrow mobile-main__angle-arrow_yellow-back"></button>
      </div>
    </transition>

  </div>
</template>

<script>
import { TweenLite , TimelineLite, Linear } from 'gsap';
import getScale from './zoom';
import Logo from '@/components/Logo';
import isMobile from '@/components/isMobile';

window.addEventListener("load", function(event) {
    if(document.getElementsByClassName('preloader')[0]){
      document.getElementsByClassName('preloader')[0].classList.add('preloader-gone');
    }
});


export default {
  data() {
    return {
      scale: {
        transform: `scale(${getScale()})`,
      },
      digital: {
        isActive: false,
        path: {
          bg: [
            // default
            '80 54 80 700 377 700 307 54',
            // hover
            '0 55 77 754 377 700 303 0',
          ],
          hero: [
            // default
            '80 54 80 700 467 700 503 0',
            // hover
            '0 55 77 754 475 683 503 0',
          ],
        },
        mobile: {
          isActive: false,
          path: {
            bg: [
              // default
              '0 0 0 1000 1000 800 1000 0',
              // hover
               '0 0 0 1000 1000 1000 1000 0',
            ]
          },
        }
      },
      video: {
        isActive: false,
        path: {
          bg: [
            // default
            '0 54 70 700 391 700 320 54',
            // hover
            '0 60 77 754 391 705 315 0',
          ],
        },
        mobile : {
          isActive: false,
          path: {
            bg: [
              // default
              '0 200 0 1000 1000 800 1000 0',
              // hover
              '0 0 0 1000 1000 1000 1000 0',
            ],
          },
        },
      },
      events: {
        isActive: false,
        path: {
          bg: [
            // default
            '0 52 72 700 295 700 295 54',
            // hover
            '0 52 75 752 376 700 304 0',
          ],
        },
        mobile: {
          isActive: false,
          path: {
            bg: [
              // default
              '0 200 0 1000 1000 1000 1000 0',
              // hover
              '0 0 0 1000 1000 1000 1000 0',
            ],
          },
        },
      },
      duration: 0.3,
      digitalBg: '',
      mobileDigitalBg:'',
      digitalHero: '',
      videoBg: '',
      eventsBg: '',

    //mobile variable
      mobile: false,
      mobileMenuOpen: false,
      coeficcientHeight:6.25,
      mobileActiveItem: '',
      digitalPoints:'',
      videoPoints:'',
      eventsPoints:'',
      mobileItemIsShow:true,
      isSlide:false,
      showLandscapeLock:false
    };
  },
  components: {
    Logo
  },

  created() {
    this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) ? 'browsers-chrome' : null;
    this.isEdge = window.navigator.userAgent.indexOf('Edge') > -1;

    if (isMobile()) {
      this.mobile = true;
      this.bodySelector = document.getElementsByTagName('body')[0];
      this.bodySelector.style.minHeight = 'auto';
      this.bodySelector.style.boxShadow = 'none';
    }
  },
  mounted() {
    if (this.$route.hash === '#video') {
      this.$modal.show('video');
    }

    this.digitalBg = this.digital.path.bg[0];
    this.digitalHero = this.digital.path.hero[0];
    this.videoBg = this.video.path.bg[0];
    this.eventsBg = this.events.path.bg[0];
    window.addEventListener('resize', () => {
      this.scale.transform = `scale(${getScale()})`;
    });
    if (isMobile()) {
      //mobile
      this.digitalPoints  = this.digital.mobile.path.bg[0];
      this.videoPoints = this.video.mobile.path.bg[0];
      this.eventsPoints = this.events.mobile.path.bg[0];
        this.firstGear = .2;
        this.secondGear = .05 ;
        this.digitalmobTl = this.createAnim('digital');
        this.videomobTl = this.createAnim('video');
        this.eventsmobTl = this.createAnim('events');
        TweenLite.defaultEase = Power0.easeNone;
        if(Object.keys(this.$route.params).length){
            this.playanim(this.$route, null);
        }
        window.addEventListener("orientationchange", ()=> {
          this.orientationChange(window.orientation);
        });

        this.orientationChange(window.orientation);

    }

    if (document.readyState === 'complete') {
      if(document.getElementsByClassName('preloader')[0]){
        document.getElementsByClassName('preloader')[0].classList.add('preloader-gone');
      }
    }
  },
  watch: {
    $route(to, from) {
      if (isMobile()) {
        this.playanim(to, from);
      }
    }
  },
  methods: {
    orientationChange(angle){

      if(angle == 0){
        //this.getElem('mobile-video-build-1').setAttribute('x', '0')
        this.showLandscapeLock = false;
      } else if (angle == 90 || angle == -90){
        this.showLandscapeLock = true;
        //this.getElem('mobile-video-build-1').setAttribute('x', '700')
      }
    }, 
    getClassNameToLogo(className) {
      this.$emit('classNameLogo', className);
    },
    onMobileMenuTap: function(){
        this.mobileMenuOpen = !this.mobileMenuOpen;
        if(this.mobileMenuOpen){
            document.getElementsByTagName('html')[0].style.height = '100%';
            document.getElementsByTagName('html')[0].style.overflow = 'hidden';
            document.getElementsByTagName('body')[0].style.height = '100%';
            document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            document.body.classList.add('mobile-menu-active')
        } else {
           document.getElementsByTagName('html')[0].style.height = 'auto';
            document.getElementsByTagName('html')[0].style.overflow = 'auto';
            document.getElementsByTagName('body')[0].style.height = '100vh';
            document.getElementsByTagName('body')[0].style.overflow = 'auto';
            document.body.classList.remove('mobile-menu-active')
        }
    },
    mouseOverDigital: function() {

      this.digital.isActive = !this.digital.isActive;
      if (this.digital.isActive) {
        this.getClassNameToLogo('digital-active');
        TweenLite.to(
          this.$data,
          this.duration,
          { digitalBg: this.digital.path.bg[1],
            digitalHero: this.digital.path.hero[1] },
        );
        if (this.isEdge) {
          // bug latest edge, after animation, redraw svg
          TweenLite.to('#digital_svg', this.duration, { 'margin-bottom': '1px' });
          TweenLite.to('#digital_svg', this.duration, { 'margin-bottom': '2px', delay: 0.1 });
        }
      } else {
        this.getClassNameToLogo();
        TweenLite.to(
          this.$data,
          this.duration,
          { digitalBg: this.digital.path.bg[0],
            digitalHero: this.digital.path.hero[0] },
        );
        if (this.isEdge) {
          // bug latest edge, after animation, redraw svg
          TweenLite.to('#digital_svg', this.duration, { 'margin-bottom': '3px' });
          TweenLite.to('#digital_svg', this.duration, { 'margin-bottom': '4px', delay: 0.1 });
        }
      }
    },
    getElem(key){
      
      return document.getElementById(key);
    },
    getByClass(key){
        return document.getElementsByClassName(key);
    },
    getHeroTranslate(key){
      switch(key){
        case 'digital': 
          return 'translateX(-100%)'; 
          break;
        case 'video': 
          return 'translateX(100%)';
         break;
        case 'events': 
          return 'translateX(-100%)'; 
         break;
      }
    },
    getHeroLogoTranslate(key){
      switch(key){
        case 'digital': 
          return 'translate3d(34vmin,10vmin,0)'; 
          break;
        case 'video': 
          return 'translate3d(16vmin,14vmin,0'; 
         break;
        case 'events': 
          return 'translate3d(30vmin,20vmin,0)'; 
         break;
      }
    },
    getHeroLogoTranslateStart(key){
      switch(key){
        case 'digital': 
          return 'matrix(1, 0, 0, 1, 80, 17)'; 
          break;
        case 'video': 
          return 'matrix(1, 0, 0, 1, 80, 17)'; 
         break;
        case 'events': 
          return 'matrix(1, 0, 0, 1, 70, 17)'; 
         break;
      }
    },
    getItemHeight(key){
      switch(key){
        case 'digital': 
          return '47vw'; 
          break;
        case 'video': 
          return '47vw'; 
         break;
        case 'events': 
          return '50vw'; 
         break;
      }
    },
    getBgColor(key){
      switch(key){
        case 'digital': 
          return '#24B0BF'; 
          break;
        case 'video': 
          return '#E0D724'; 
         break;
        case 'events': 
          return '#FF7445'; 
         break;
      }
    },
    createAnim(key){
      return new TimelineLite()
                  .set(this.getElem('info-' + key + '-text'), {transform:'matrix(1, 0, 0, 1, -1000, 0)','-webkit-transform':'matrix(1, 0, 0, 1, -1000, 0)'})
                  .set(this.getElem('link-' + key + '-group'), {transform:'matrix(1, 0, 0, 1, -1000, 0)','-webkit-transform':'matrix(1, 0, 0, 1, -1000, 0)'})
                  .add(TweenLite.to(document.getElementsByTagName('body')[0],this.firstGear, {backgroundColor:this.getBgColor(key)}))
                  .add(TweenLite.to(this.getElem(key + '-item'),this.secondGear, {transform:'translateY(-85px)','-webkit-transform':'translateY(-85px)'}))
                  .add(TweenLite.to(this.$data,this.secondGear, { [ key + 'Points' ]:this[key].mobile.path.bg[1]}))
                  .add(TweenLite.to(this.getElem('mobile-' + key + '-hero-logo'),this.firstGear, {transform:this.getHeroLogoTranslateStart(key),'-webkit-transform':this.getHeroLogoTranslateStart(key)}))
                  .add(TweenLite.to(this.getElem('mobile-' + key + '-hero'),this.firstGear, {transform:this.getHeroTranslate(key),'-webkit-transform':this.getHeroTranslate(key)}))
                  .add(TweenLite.to(this.getElem('mobile-' + key + '-build-0'),this.firstGear, {transform:'matrix(1, 0, 0, 1, -1000, 0)','-webkit-transform':'matrix(1, 0, 0, 1, -1000, 0)'}))
                  .add(TweenLite.to(this.getElem(key + '-item'),this.secondGear, {height:'90%',minHeight:'auto'}))
                  .add(TweenLite.to(this.getElem('mobile-' + key + '-build-1'),this.firstGear, {transform:'translateY(0)','-webkit-transform':'translateY(0)'}))
                  .add(TweenLite.to(this.getElem('info-' + key + '-text'),this.firstGear, {transform:'translateX(0)','-webkit-transform':'translateY(0)', opacity:'1'}))
                  .add(TweenLite.to(this.getElem(key + '-hero_preview-2'),this.firstGear, {transform:'matrix(1, 0, 0, 1, 0, 0)','-webkit-transform':'matrix(1, 0, 0, 1, 0, 0)'}))
                  .add(TweenLite.to(this.getElem('link-' + key + '-group'),this.firstGear, {transform:'matrix(1, 0, 0, 1, 0, 0)','-webkit-transform':'matrix(1, 0, 0, 1, 0, 0)', opacity:'1'}))
                  .add(TweenLite.to(this.getByClass('mobile-main__angle-arrow'),this.firstGear, {opacity:'1'}))
                  .pause(0);
    },
    playanim(to, from){
      this.bodySelector.scrollTop = 0;
      if(!to.params.name){
          this[from.params.name + 'mobTl'].reverse();
          this[from.params.name + 'mobTl'].eventCallback("onReverseComplete", ()=>{
            this.mobileItemIsShow = true;
            this.mobileActiveItem = null; 
            this.digitalmobTl.pause(0);
            this.videomobTl.pause(0);
            this.eventsmobTl.pause(0);
            TweenLite.to(document.getElementsByTagName('body')[0], this.firstGear, {'backgroundColor': '#171d29'});
            TweenLite.to(this.getElem('mobile-' + 'digital' + '-hero-logo'), this.firstGear, {transform:this.getHeroLogoTranslate('digital'),'-webkit-transform':this.getHeroLogoTranslate('digital')});
            TweenLite.to(this.getElem('mobile-' + 'video' + '-hero-logo'), this.firstGear, {transform:this.getHeroLogoTranslate('video'),'-webkit-transform':this.getHeroLogoTranslate('video')});
            TweenLite.to(this.getElem('mobile-' + 'events' + '-hero-logo'), this.firstGear, {transform:this.getHeroLogoTranslate('events'),'-webkit-transform':this.getHeroLogoTranslate('events')});
            TweenLite.to(this.getElem('events-hero_preview-2'), this.firstGear, {transform:'matrix(1, 0, 0, 1, 0, 1000)','-webkit-transform':'matrix(1, 0, 0, 1, 0, 1000)'});
          });
          return false;
      }  
      this.mobileItemIsShow = false;
      this.mobileActiveItem = to.params.name + 'ActiveItem'; 
      if(this.isSlide || (window.screen.height / window.screen.width == 1.5) && (window.devicePixelRatio == 2)){  //slide or iPhone 4/4s
        this[to.params.name + 'mobTl'].progress(1, false);
      } else {
        this[to.params.name + 'mobTl'].play();
      }
    },
    mobileTapItem: function(key, isMenu, isSlide) {
       if( this.mobileActiveItem == key + 'ActiveItem' ){
          this.isSlide = null;
          this.$router.push({ path: '/' });
       } else {
          if(isSlide){
            this.isSlide = isSlide;
          }
          this.$router.push({ path: '/detail/' + key });
       } 
       if(isMenu){
          this.onMobileMenuTap();
       }
    },
    mouseOverVideo: function() {
      this.video.isActive = !this.video.isActive;

      if (this.video.isActive) {
        this.getClassNameToLogo('video-active');
        TweenLite.to(
          this.$data,
          this.duration,
          { videoBg: this.video.path.bg[1] },
        );
      } else {
        this.getClassNameToLogo();
        TweenLite.to(
          this.$data,
          this.duration,
          { videoBg: this.video.path.bg[0] },
        );
      }
    },
    mouseOverEvents: function() {
      this.events.isActive = !this.events.isActive;

      if (this.events.isActive) {
        this.getClassNameToLogo('events-active');
        TweenLite.to(
          this.$data,
          this.duration,
          { eventsBg: this.events.path.bg[1] },
        );
      } else {
        this.getClassNameToLogo();
        TweenLite.to(
          this.$data,
          this.duration,
          { eventsBg: this.events.path.bg[0] },
        );
      }
    },
    mobileSuperAspectRatioCalcWidth: function(width){
      let megaCoeficcient = 3.4;
      return megaCoeficcient * width/2;
    },
    mobileSuperAspectRatioCalcHeight: function(height, altCoef){
     // if(altCoef) this.coeficcientHeight = 1.8;
      return this.coeficcientHeight * height/2;
    },
    gaClickLogo() {
      this.$gtm.trackEvent({
        event: 'event',
        event_category: 'wng_common',
        event_action: 'click',
        event_label: 'main'
      });
    },
    gaClickDigital() {
      this.$gtm.trackEvent({
        event: 'event',
        event_category: 'wng_main',
        event_action: 'click',
        event_label: 'digital',
      });
    },
    gaClickVideo() {
      this.$gtm.trackEvent({
        event: 'event',
        event_category: 'wng_main',
        event_action: 'click',
        event_label: 'video',
      });
    },
    gaClickBtl() {
      this.$gtm.trackEvent({
        event: 'event',
        event_category: 'wng_main',
        event_action: 'click',
        event_label: 'btl',
      });
    },
    gaClickNav(link) {
      let label = null;

      if (link === "digital") {
        label = "digital";
      } else if (link === "video") {
        label = "video";
      } else if (link === "events") {
        label = "btl";
      }

      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_common",
        event_action: "click",
        event_label: label
      });
    },
    gaClickPrev() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_common",
        event_action: "click",
        event_label: "prev"
      });
    },
    gaClickNext() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_common",
        event_action: "click",
        event_label: "next"
      });
    },
    gaClickPhone() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_common",
        event_action: "click",
        event_label: "tel"
      });
    },
    gaClickEmail() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_common",
        event_action: "click",
        event_label: "email"
      });
    },
    gaClickDititalPortfolio() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_digital",
        event_action: "click",
        event_label: "portfolio"
      });
    },
    gaClickDititalSite() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_digital",
        event_action: "click",
        event_label: "site"
      });
    },
    gaClickVideoPortfolio() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_video",
        event_action: "click",
        event_label: "portfolio"
      });
    },
    gaClickVideoSite() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_video",
        event_action: "click",
        event_label: "site"
      });
    },
    gaClickVideoVimeo() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_video",
        event_action: "click",
        event_label: "vimeo"
      });
    },
    gaClickBtlPortfolio() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_btl",
        event_action: "click",
        event_label: "portfolio"
      });
    },
    gaClickShowVideo1() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_btl",
        event_action: "show",
        event_label: "video1"
      });
    }
  },
};
</script>

<!-- <style>
  @import '../styles/main.css';
  @import '../styles/digital.css';
</style> -->

<style src="@/styles/main.css"></style>
<style src="@/styles/digital.css"></style>
<style src="@/styles/video.css"></style>
<style src="@/styles/events.css"></style>



// WEBPACK FOOTER //
// src/components/Main.vue